import { compareAsc } from 'date-fns'

import { ScheduleShift } from '@/entities/Shift/Shift'
import { formatDate } from '@/helpers/legacyDate/parser'
import { legacyParse } from '@/helpers/legacyDateParser'
import { doesShiftFallOnWorkDay } from '@/services/ShiftService/doesShiftFallOnWorkDay'

export function filterShiftsByDays(shifts: ScheduleShift[], day: Date): ScheduleShift[] {
    return shifts
        .filter((shift) => doesShiftFallOnWorkDay(shift, day))
        .sort((a, b) => compareAsc(legacyParse(a.period.start), legacyParse(b.period.start)))
}

export function getHeader(day: Date) {
    return formatDate(new Date(day), 'EEEEEE')
}
